
import request from '@/axios/index.js'
const uri = '/user/fncDetails/';

export function pagingFncDetails(data,loading) {
    return request.axios({
        loading:loading,
        data:data,
        url: uri+'pagingFncDetails'
    })
}
// 融资详情贸易背景
export function queryTradeBGByFncJrnlId(data,loading) {
  return request.axios({
      loading:loading,
      data:data,
      url: '/fund/queryTradeBGByFncJrnlId',
      contentType:'application/json'
  })
}



// WEBPACK FOOTER //
// ./src/api/fncDetails.js